export default __webpack_public_path__ + "static/media/utx.735fab4e.jpg";